/**
 * Дашборд (ADMIN_SPEC §11, design Handoff 6). Оркестратор: сводка метрик по
 * периоду (мок-запрос), сегмент периода, клик по рискам → «Клиенты» с фильтром
 * статуса, «Создать аккаунт» → «Клиенты». Раскладка — десктоп/мобилка через
 * useBreakpoint. Графики «Трендов» — следующим этапом (Recharts).
 */

import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useQuery} from '@tanstack/react-query';

import type {SubscriptionStatus} from '@services/clients';
import {dashboardSummaryQueryOptions} from '@services/dashboard';
import {useBreakpoint} from '@hooks/useBreakpoint';
import {useToast} from '@hooks/useToast';
import {Toast} from '@components/Toast';

import {type DashPeriod, dashPeriodKey} from './Dashboard.utils';
import {DashboardDesktop} from './DashboardDesktop';
import {DashboardMobile} from './DashboardMobile';

export const Dashboard = () => {
  const {isMobile} = useBreakpoint();
  const navigate = useNavigate();
  const {toast, notify} = useToast();

  const [period, setPeriod] = useState<DashPeriod>('month');
  const {data, isLoading} = useQuery(dashboardSummaryQueryOptions(dashPeriodKey(period)));

  const layoutProps = {
    summary: data,
    isLoading,
    period,
    onPeriod: setPeriod,
    onPickRisk: (status: SubscriptionStatus) => navigate(`/clients?status=${status}`),
    onCreate: () => navigate('/clients?create=1'),
    onSoon: (text: string) => notify(text),
  };

  return (
    <>
      {isMobile ? <DashboardMobile {...layoutProps} /> : <DashboardDesktop {...layoutProps} />}
      <Toast message={toast} />
    </>
  );
};
